module.exports = __webpack_public_path__ + "static/brand1-cdc435629393e5de969cb51171e2e8e2.png";